import { render, staticRenderFns } from "./PlaceDetailsModal.vue?vue&type=template&id=e8654db2&scoped=true&"
import script from "./PlaceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PlaceDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./PlaceDetailsModal.vue?vue&type=style&index=0&id=e8654db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8654db2",
  null
  
)

export default component.exports